import type { FC, PropsWithChildren } from 'react';
import React, { useMemo, useRef } from 'react';

import { ArticleScrollContext } from './context';

const ArticleScrollProvider: FC<PropsWithChildren> = ({ children }) => {
  const scrollDestinationRef = useRef(null);
  const value = useMemo(() => ({ scrollDestinationRef }), [scrollDestinationRef]);

  return <ArticleScrollContext.Provider value={value}>{children}</ArticleScrollContext.Provider>;
};

export default ArticleScrollProvider;
